import { render } from "./ShowReviewMatrix.vue?vue&type=template&id=34218776&ts=true"
import script from "./ShowReviewMatrix.ts?vue&type=script&lang=ts&external"
export * from "./ShowReviewMatrix.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__